import React from 'react';
import PropTypes from 'prop-types';

const SingleArrowLeft = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 477.2 477.2" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g>
        <path d="M116.5,246.7l225.1,192c2.6,2.3,6.1,3.4,9.5,3.4s6.9-1.2,9.5-3.4c5.3-4.5,5.3-11.8,0-16.3L145.1,238.6L360.6,54.8
                c5.3-4.5,5.3-11.8,0-16.3s-13.8-4.5-19.1,0l-225.1,192C111.2,234.9,111.2,242.3,116.5,246.7z" color={color} />
      </g>
    </svg>
  );
}

SingleArrowLeft.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

SingleArrowLeft.defaultProps = {
  color: '#000000',
  width: 477.2,
  height: 477.2,
};

export default SingleArrowLeft;



// WEBPACK FOOTER //
// ./src/components/Icons/SingleArrowLeft.jsx